import { ApiProductCard } from '../../api';

class ProductItemSelectEvent {
  item: ApiProductCard;
}

export default ProductItemSelectEvent;
